<template>
  <div class="ai-menu-initing" @click="handleOpenInit">
    <div class="ai-menu-initing__frame">
      <div class="ai-menu-initing__title">
        <span class="ai-menu-initing__title-emoji">🖐️</span>
        <span class="ai-menu-initing__title-text">轻松 5 步让 AI 更好用</span>
      </div>
      <div class="ai-menu-initing__card">
        <div class="ai-menu-initing__preview">
          <div class="ai-menu-initing__grid"></div>
          <div class="ai-menu-initing__preview-content">
            <img alt="AI 智能生成中..." class="ai-menu-initing__preview-image" :src="aiLogoEmpty" />
            <div class="ai-menu-initing__preview-title">
              <i class="ai-menu-initing__preview-icon icon-sparkling-2-fill t-iconfont"></i>
              <span>AI 智能生成中...</span>
            </div>
            <div class="ai-menu-initing__preview-desc">正在生成公司业务说明</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import aiLogoEmpty from '@/assets/chatbot.svg'

defineOptions({
  name: 'AiMenuIniting'
})

const handleOpenInit = () => {
  window.__openAiInitSetupDialog()
}
</script>

<style lang="scss" scoped>
.ai-menu-initing {
  padding: 16px 16px 0;

  &__frame {
    padding: 12px;
    border: 1px solid transparent;
    border-radius: 16px;
    box-sizing: border-box;
    background:
      -webkit-linear-gradient(#ffffff, #ffffff) padding-box,
      -webkit-linear-gradient(118deg, #1574ff 3%, #5952ff 52%, #a969fe 96%) border-box;
  }

  &__title {
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  &__title-emoji {
    margin-right: 4px;
    color: #323233;
    font-size: 14px;
    font-weight: 600;
  }

  &__title-text {
    font-size: 14px;
    font-weight: 600;
    background: linear-gradient(276deg, #090120 1%, #4f16c1 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  &__card {
    margin-top: 12px;
  }

  &__preview {
    position: relative;
    height: 156px;
    overflow: hidden;
    border: 1px solid #f2f3f5;
    border-radius: 20px;
    background: rgba(248, 250, 255, 0.6);
  }

  &__grid {
    position: absolute;
    inset: 0;
    z-index: 1;
    background-image:
      linear-gradient(rgba(220, 225, 235, 0.6) 1px, transparent 1px),
      linear-gradient(90deg, rgba(220, 225, 235, 0.6) 1px, transparent 1px);
    background-size: 16px 16px;
    animation: moveGridUp 1s linear infinite;
    pointer-events: none;
  }

  &__preview::after {
    position: absolute;
    inset: 0;
    z-index: 2;
    content: '';
    background: radial-gradient(circle at center, transparent 68%, #f8faff 95%);
    pointer-events: none;
  }

  &__preview-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
  }

  &__preview-image {
    width: 152px;
    height: 76px;
  }

  &__preview-title {
    display: flex;
    align-items: center;
    margin-top: 8px;
    color: #323233;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  &__preview-desc {
    margin-top: 2px;
    color: #969799;
    font-size: 13px;
    line-height: 18px;
  }

  &__preview-icon {
    margin-right: 8px;
    font-size: 16px;
    line-height: 16px;
    background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
}

@keyframes moveGridUp {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 0 calc(-1 * 16px);
  }
}
</style>
